import { FormControlLabel, Switch, SwitchProps, styled } from "@mui/material";
import * as React from "react";
import show from "../../../UI/general/show.svg";
import hide from "../../../UI/general/hide.svg";
declare const window: any;

export default function ShowOverlayContainer({
  setShowTextHotspots,
  showTextHotspots,
  colors,
  theme
}: any) {
  React.useEffect(() => {
      const setting_botton: any = document.querySelector(
        ".setting-boton-cotizacion"
      );
      if (!showTextHotspots) {
        if (setting_botton) {
          setting_botton.style.backgroundColor = colors?.main_buttons;
        }
      } else {
        if (setting_botton) {
          if (theme === "Glass") {
            setting_botton.style.backgroundColor = "rgba(150, 150, 150, 0.6)";
            setting_botton.style.backdropFilter = "blur(10px) contrast(120%)";
            setting_botton.style.boxShadow =
              "0 0 0.625rem 0.2rem rgba(0, 0, 0, 0.2)";
            setting_botton.style.color = "#fff";
          } else if (theme === "Light") {
            setting_botton.style.backgroundColor = "rgba(255, 255, 255, 1)";
            setting_botton.style.color = "#212427";
          } else if (theme === "Dark") {
            setting_botton.style.backgroundColor = "#212427";
            setting_botton.style.color = "#fff";
          }
        }
      }
    }, [showTextHotspots]);
  
    const darkenColor = (color, percent) => {
      const f = parseInt(color.slice(1), 16);
      const t = percent < 0 ? 0 : 255;
      const p = percent < 0 ? percent * -1 : percent;
      const R = f >> 16;
      const G = (f >> 8) & 0x00ff;
      const B = f & 0x0000ff;
      return (
        "#" +
        (
          0x1000000 +
          (Math.round((t - R) * p) + R) * 0x10000 +
          (Math.round((t - G) * p) + G) * 0x100 +
          (Math.round((t - B) * p) + B)
        )
          .toString(16)
          .slice(1)
      );
    };
    
  
    return (
      <div
        className={`setting-boton-show-hide-overlay`}
        style={{
          backgroundColor:
            theme === "Light"
              ? "rgba(255, 255, 255, 1)"
              : theme === "Glass"
              ? "rgba(150, 150, 150, 0.6)"
              : theme === "Dark"
              ? "#212427"
              : "#212427",
          color: theme === "Light" ? "#212427" : "#fff",
          backdropFilter:
            theme === "Glass" ? "blur(10px) contrast(120%)" : "none",
          boxShadow:
            theme === "Glass" ? "0 0 0.625rem 0.2rem rgba(0, 0, 0, 0.2)" : "none",
        }}
        onMouseOver={(e) => {
          if (showTextHotspots) {
            e.currentTarget.style.backgroundColor = darkenColor(
              colors?.main_buttons,
              -0.2
            );
            e.currentTarget.style.color = "#fff";
          }
        }}
        onMouseOut={(e) => {
          if (showTextHotspots) {
            e.currentTarget.style.backgroundColor = theme === "Light"
              ? "rgba(255, 255, 255, 1)"
              : theme === "Glass"
              ? "rgba(150, 150, 150, 0.6)"
              : theme === "Dark"
              ? "#212427"
              : "#212427";
            e.currentTarget.style.color = theme === "Light" ? "#212427" : "#fff";
            e.currentTarget.style.backdropFilter = theme === "Glass" ? "blur(10px) contrast(120%)" : "none";
            e.currentTarget.style.boxShadow = theme === "Glass" ? "0 0 0.625rem 0.2rem rgba(0, 0, 0, 0.2)" : "none";
            return;
          }
        }}
        onClick={() => {setShowTextHotspots(!showTextHotspots)}}
      >
        <img src={showTextHotspots ? hide : show} alt="" />
      </div>
    );
}
